<template>
  <SlideIn
    :open="isOpen"
    heading="Shop the Look"
    :content-padding="false"
    @close="isOpen = false"
  >
    <template #content>
      <div class="quick-product">
        <div v-if="images" class="quick-product__carousel">
          <div
            v-for="image in images"
            :key="image.id"
            class="quick-product__image-wrapper"
            :style="{
              'background-image': image.blurry && `url(${image.blurry})`,
            }"
          >
            <Media :images="image" :sources="image.sources" cover />
          </div>
        </div>
        <div class="quick-product__content">
          {{ product.title }}
          <ProductCardPrice :product="product" class="quick-product__price" />
          <Variants
            v-if="showVariants"
            hide-media
            class="quick-product__variants"
          />
          <div class="quick-product__actions">
            <AddToBag @clicked="setOpenQuickLook(false)" />
            <Button
              theme="secondary"
              tag="a"
              :href="product.onlineStoreUrl"
              width="full"
            >
              See Full details
            </Button>
          </div>
        </div>
      </div>
    </template>
  </SlideIn>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import SlideIn from "@/components/SlideIn.vue";
import ProductCardPrice from "@/components/product-card/ProductCardPrice.vue";
import AddToBag from "@/components/product-display/AddToBagV2.vue";
import Variants from "@/components/product-display/Variants.vue";
import Button from "@/components/ButtonV3.vue";
import { productImageSequence } from "@/helpers/imageSequences.js";
import Media from "@/components/Media.vue";

export default {
  name: "MiniProduct",
  components: {
    SlideIn,
    ProductCardPrice,
    AddToBag,
    Variants,
    Button,
    Media,
  },
  computed: {
    ...mapState("product", ["product", "openQuickLook"]),
    ...mapGetters("product", ["variants"]),
    images() {
      const media = productImageSequence
        .map((sequence) => {
          let mediaItem;

          if (sequence.includes("Video")) {
            mediaItem = this.getFirstReference(
              this.product[sequence]?.references.edges
            );
          } else {
            mediaItem = this.getFirstReference(
              this.product[sequence]?.references.edges
            )?.image;
          }

          if (!mediaItem) {
            return null;
          }

          return mediaItem;
        })
        .filter((mediaItem) => mediaItem !== null);

      return media;
    },
    isOpen: {
      get() {
        return this.openQuickLook;
      },
      set(value) {
        return this.setOpenQuickLook(value);
      },
    },
    showVariants() {
      return this.variants.length > 1;
    },
  },
  methods: {
    ...mapActions("product", ["setOpenQuickLook"]),
    getFirstReference(references) {
      if (!references) return null;
      const nodes = references.map((reference) => reference.node);
      return nodes[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.quick-product {
  padding: 20px 0;
}

.quick-product__carousel {
  display: flex;
  overflow-y: hidden;
  flex-flow: row nowrap;
  scroll-snap-type: x mandatory;
  gap: 4px;
  margin-bottom: 20px;
  padding-left: 20px;

  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    scroll-snap-align: start;
    scroll-snap-stop: always;
    flex: 0 0 240px;
    scroll-margin-left: 20px;
  }
}

.quick-product__image-wrapper {
  aspect-ratio: 4/5;
  background-size: cover;
  background-position: center center;
}

.quick-product__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  display: block;
}

.quick-product__content {
  padding: 0 20px;
}

.quick-product__variants {
  margin-bottom: 20px;
}

.quick-product__actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quick-product__price {
  margin-bottom: 20px;
}
</style>
